exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".free___2nMKU {\n  color: #505050;\n  display: inline-block;\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 16px;\n  font-stretch: normal;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-height: 1.5;\n  position: relative;\n}\n.freeImg___1kqJk {\n  bottom: 0;\n  font-size: 32px;\n  left: 0;\n  position: absolute;\n}\n", ""]);

// exports
exports.locals = {
	"free": "free___2nMKU",
	"freeImg": "freeImg___1kqJk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/paper/components/Free/styles.module.less
// module id = 1784
// module chunks = 70